import { Box, Skeleton, Grid2 } from '@mui/material';

const TickerSkeleton = () => {
  return (
    <Box display="flex" alignItems="center" gap={2} py={1}>
      {/* Symbol and Label */}
      <Skeleton variant="circular" width={24} height={24} />
      <Skeleton variant="text" width={80} height={30} />
      <Skeleton variant="rounded" width={40} height={20} />

      {/* Price */}
      <Skeleton variant="text" width={80} height={30} />

      {/* USD Price */}
      <Skeleton variant="text" width={90} height={20} />

      {/* 24h Stats */}
      <Grid2 container spacing={2} sx={{ ml: 2, flexWrap: 'nowrap' }}>
        {['24h High', '24h Low', '24h Volume (ETH)', '24h Volume (USDT)'].map((label, index) => (
          <Grid2 item key={index}>
            <Skeleton variant="text" width={120} height={20} />
            <Skeleton variant="text" width={80} height={25} />
          </Grid2>
        ))}
      </Grid2>

      {/* Options Button */}
      <Skeleton variant="circular" width={20} height={20} sx={{ ml: 2 }} />
    </Box>
  );
};

export default TickerSkeleton;
